import { Component } from '@angular/core';
import { ProductMenuFooterComponent } from '../product-menu-footer.component';
import { VariantBadge } from '../../../../../../../../models/product/dto/variant-badge';
import { FilterUtils } from '../../../../../../../../utils/filter-utils';

@Component({
  selector: 'app-plantlife-cheap-weed-footer',
  templateUrl: './plantlife-cheap-weed-footer.component.html',
  styleUrls: ['./plantlife-cheap-weed-footer.component.scss'],
  standalone: false
})
export class PlantlifeCheapWeedFooterComponent extends ProductMenuFooterComponent {
  public removePLKeywordBadges = (badge: VariantBadge) => {
    return FilterUtils.keepPlantLifeTaggedBadges(badge) && FilterUtils.removeBadgesWith86Keyword(badge);
  };
}
